import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  .ant-drawer.modal-drawer.drawer-closable {
    .ant-drawer-header-title {
      flex-direction: row-reverse;
    }
  }
  .ant-drawer.operationsModal {
    .ant-drawer-body {
      padding: 16px;
    }
    .ant-drawer-title {
      :after {
        display: none;
      }
    }
  }
  .ant-drawer.modal-drawer.permissoes-acesso-modal {
    .ant-drawer-body {
      padding: 0;
      table {
        .ant-table-cell {
          width: 20%;
          font-size: 11px;
        }
        .ant-table-cell:first-of-type {
          width: 40%;
          font-size: 12px;
          padding: 8px 0 8px 8px;
        }
        .ant-table-cell:not(:first-of-type) {
          padding: 8px 4px;
        }
      }
    }
  }
  .ant-drawer.modal-drawer {
    color: var(--velotax-font-color);
    .ant-drawer-content-wrapper {
      .ant-drawer-content {
        .ant-drawer-wrapper-body {
          .ant-drawer-header {
            .ant-drawer-header-title {
              height: 32px;
              .ant-drawer-close {
                margin: 0;
              }
              .ant-drawer-title {
                padding: 8px 0;
                font-size: 18px;
                font-weight: 600;
                position: relative;
                :after {
                  content: "";
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  width: 80px;
                  height: 2px;
                  background-color: var(--ant-primary-color);
                }
              }
            }
          }
        }
      }
    }
  }
`;
